/*!
 * Halloween Ghost Cursor Trail
 * - No background, no text, no buttons. A small witch-hat ghost follows the
 *   visitor's cursor with a short delay, with 2-3 smaller faded copies
 *   trailing behind it for a wispy effect.
 * - Runs the whole visit (not a one-time intro). On touch devices it follows
 *   the finger while touching, and idles gently otherwise.
 *
 * Install: add this line before </body>
 *   <script src="halloween-ghost-trail.js" defer></script>
 *
 * Optional settings (put BEFORE the script tag):
 *   <script>
 *     window.HALLOWEEN_GHOST_TRAIL = {
 *       ghosts: 4,       // total ghosts in the chain (1 leader + followers)
 *       size: 46,        // pixel size of the leader ghost
 *       ease: 0.16,       // 0-1, how quickly each ghost catches up (lower = laggier)
 *       opacityMin: 0.18 // faintest opacity of the last ghost in the chain
 *     };
 *   </script>
 */
(function () {
  var cfg = window.HALLOWEEN_GHOST_TRAIL || {};
  var COUNT   = cfg.ghosts   != null ? cfg.ghosts   : 4;
  var SIZE    = cfg.size     != null ? cfg.size     : 46;
  var EASE    = cfg.ease     != null ? cfg.ease     : 0.16;
  var OP_MIN  = cfg.opacityMin != null ? cfg.opacityMin : 0.18;

//   if (
//   (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
//   (window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches)
// ) return;

  function run() {
    var layer = document.createElement('div');
    layer.setAttribute('aria-hidden', 'true');
    layer.style.cssText = 'position:fixed;left:0;top:0;width:100%;height:100%;z-index:2147483000;pointer-events:none;overflow:hidden';
    document.body.appendChild(layer);

    var svgGhost =
      '<svg viewBox="0 0 100 110" width="100%" height="100%" style="display:block;overflow:visible">' +
        '<path d="M15 46 Q15 6 50 6 Q85 6 85 46 L85 94 ' +
          'Q78 106 71 94 Q64 106 57 94 Q50 106 43 94 Q36 106 29 94 Q22 106 15 94 Z" fill="currentColor"/>' +
        '<circle cx="36" cy="48" r="7" fill="#1a1024"/>' +
        '<circle cx="64" cy="48" r="7" fill="#1a1024"/>' +
      '</svg>';

    var nodes = [];
    for (var i = 0; i < COUNT; i++) {
      var el = document.createElement('div');
      var s = SIZE * (1 - i * 0.16);
      var op = i === 0 ? 1 : (1 - i / (COUNT - 0.2)) * (1 - OP_MIN) + OP_MIN;
      el.style.cssText = 'position:absolute;left:0;top:0;width:' + s + 'px;height:' + (s * 1.1) + 'px;' +
        'margin-left:' + (-s/2) + 'px;margin-top:' + (-s*0.55) + 'px;' +
        'color:#c9a6ee;opacity:' + op.toFixed(2) + ';filter:drop-shadow(0 4px 8px rgba(60,20,90,.35));' +
        'will-change:transform';
      el.innerHTML = svgGhost;
      layer.appendChild(el);
      nodes.push({ el: el, x: window.innerWidth / 2, y: window.innerHeight / 2 });
    }

    var target = { x: nodes[0].x, y: nodes[0].y };
    var active = true, raf = 0, idlePhase = 0, lastMove = performance.now();
    var overInteractive = false;

    // hide the trail while the cursor is over a link, button, or similar clickable element
    var INTERACTIVE_SELECTOR = 'a, label, button, [role="button"], input[type="submit"], input[type="select"], input[type="button"], input[type="checkbox"], input[type="text"], input[type="email"], .btn, .button';
    function setInteractiveState(el) {
      var match = el && el.closest ? el.closest(INTERACTIVE_SELECTOR) : null;
      var now = !!match;
      if (now !== overInteractive) {
        overInteractive = now;
        layer.style.transition = 'opacity .18s ease';
        layer.style.opacity = overInteractive ? '0' : '1';
      }
    }
    document.addEventListener('mouseover', function (e) { setInteractiveState(e.target); }, { passive: true });
    document.addEventListener('touchstart', function (e) {
      var t = e.touches && e.touches[0];
      var el = t ? document.elementFromPoint(t.clientX, t.clientY) : null;
      setInteractiveState(el);
    }, { passive: true });

    function onMove(x, y) { target.x = x; target.y = y; lastMove = performance.now(); }
    window.addEventListener('mousemove', function (e) { onMove(e.clientX, e.clientY); }, { passive: true });
    window.addEventListener('touchmove', function (e) {
      if (e.touches && e.touches[0]) onMove(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
    window.addEventListener('touchstart', function (e) {
      if (e.touches && e.touches[0]) onMove(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });

    function tick(now) {
      if (!active) return;
      // gentle idle drift if the cursor hasn't moved in a while (e.g. desktop, mouse still)
      if (now - lastMove > 1800) {
        idlePhase += 0.02;
        target.x += Math.sin(idlePhase) * 0.6;
        target.y += Math.cos(idlePhase * 0.8) * 0.4;
      }
      var px = target.x, py = target.y;
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        var e = i === 0 ? EASE : EASE * 0.85;
        n.x += (px - n.x) * e;
        n.y += (py - n.y) * e;
        var bob = Math.sin(now / 500 + i) * 3;
        n.el.style.transform = 'translate(' + n.x.toFixed(1) + 'px,' + (n.y + bob).toFixed(1) + 'px)';
        px = n.x; py = n.y;
      }
      raf = requestAnimationFrame(tick);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { active = false; cancelAnimationFrame(raf); }
      else if (!active) { active = true; lastMove = performance.now(); raf = requestAnimationFrame(tick); }
    });

    raf = requestAnimationFrame(tick);
  }

  if (document.body) run();
  else document.addEventListener('DOMContentLoaded', run);
})();
